import { PageHeader, type PageHeaderProps } from "@app/PageReady/PageHeader";
import { useTranslation } from "react-i18next";

export const SettingHeader = (props: PageHeaderProps) => {
  const { className, onIconClick } = props;
  const { t } = useTranslation();
  return <PageHeader title={t("Settings")} onIconClick={onIconClick} className={className} />;
};
